<div class="flex items-center">
  <div class="sidebar flex flex-col bg-primary p-4 text-white rounded-e-3xl h-screen">
    <div>
      <img src="/assets/images/logo.svg" alt="Logo" class="m-auto" [ngClass]="showMenuText? 'w-28' : 'w-14'"
        [routerLink]="[ '/home']" (click)="menuClick.emit(true)">
    </div>
    <div class="flex w-fit overflow-y-auto flex-col flex-1 gap-2 mt-8 text-sm font-semibold items-start">

      <a [routerLink]="[ '/home']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" title="Home">
        <img src="/assets/images/home.svg" alt="" srcset="">
        <span *ngIf="showMenuText">HOME</span>
      </a>

      <a [routerLink]="[ '/dashboard']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" title="Dashboard" [auth]="uiAccessList.Dashboard">
        <img src="/assets/images/home.svg" alt="" srcset="">
        <span *ngIf="showMenuText">DASHBOARD</span>
      </a>

      <a [routerLink]="[ '/dashboard/insurance']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.Insurance" title="Dashboard">
        <img class="w-8" src="/assets/images/home.svg" alt="" srcset="">
        <span *ngIf="showMenuText">CLAIM DASHBOARD</span>
      </a>

      <a [routerLink]="[ '/dashboard/icd']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" title="Dashboard"  [auth]="uiAccessList.IcdCodeHistory">
        <img class="w-8" src="/assets/images/home.svg" alt="" srcset="">
        <span *ngIf="showMenuText">ICD DASHBOARD</span>
      </a>
      <a [routerLink]="[ '/upload-report']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.UploadReport" title="Upload Lab Report">
        <img src="/assets/images/upload-icon.svg" alt="" srcset="">
        <span *ngIf="showMenuText">UPLOAD LAB REPORT</span>
      </a>

      <a [routerLink]="[ '/insurance']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.Insurance" title="Analyze Claims">
        <img class="w-8" src="/assets/images/insurance.svg" alt="" srcset="">
        <span *ngIf="showMenuText">ANALYZE CLAIMS</span>
      </a>

      <a [routerLink]="[ '/document-scanner']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)"
        [auth]="[uiAccessList.DocumentScanner, uiAccessList.MedicalRecord, uiAccessList.SpecializedFeature]"
        title="Upload Medical Record">
        <img class="w-8" src="/assets/images/doc-scanner.svg" alt="" srcset="">
        <span *ngIf="showMenuText">UPLOAD MEDICAL RECORD</span>
      </a>

      <a [routerLink]="[ '/preauth']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.PreAuth" title="Pre Auth Extraction">
        <img class="w-8" src="/assets/images/textract-white-icon.svg" alt="" srcset="">
        <span *ngIf="showMenuText">PRE AUTH EXTRACTION</span>
      </a>

      <a [routerLink]="[ '/extract-input']" routerLinkActive="active"
        class="px-4 py-2 flex gap-2 items-center" (click)="menuClick.emit(true)"
        [auth]="uiAccessList.ExtractInput" title="Extract Input">
        <img class="w-8" src="/assets/images/extract-input.png" alt="" srcset="">
        <span *ngIf="showMenuText">EXTRACT INPUT</span>
      </a>

      <a [routerLink]="[ '/medical-record-analysis']" routerLinkActive="active"
        class="px-4 py-2 flex gap-2 items-center" (click)="menuClick.emit(true)"
        [auth]="uiAccessList.MedicalRecordAnalysis" title="Medical Record Analysis">
        <img class="w-8" src="/assets/images/emr-analysis.svg" alt="" srcset="">
        <span *ngIf="showMenuText">MEDICAL RECORD ANALYSIS</span>
      </a>

      <a [routerLink]="[ '/medical-record-history']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.MedicalRecordHistory" title="Medical Record History">
        <img class="w-8" src="/assets/images/emr-history.svg" alt="" srcset="">
        <span *ngIf="showMenuText">MEDICAL RECORD HISTORY</span>
      </a>

      <a [routerLink]="[ '/icd-code-analysis']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.ICDCodeAnalysis" title="ICD Code Analysis">
        <img class="w-8" src="/assets/images/emr-analysis.svg" alt="" srcset="">
        <span *ngIf="showMenuText">ICD CODE ANALYSIS</span>
      </a>

      <a [routerLink]="[ '/report']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" title="Manual Entry" [auth]="uiAccessList.ManualEntry">
        <img src="/assets/images/test.svg" alt="" srcset="">
        <span *ngIf="showMenuText">MANUAL ENTRY</span>
      </a>

      <a [routerLink]="[ '/old-reports']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.OldReports" title="Old Reports">
        <img src="/assets/images/old-record.svg" alt="" srcset="">
        <span *ngIf="showMenuText">OLD RECORDS</span>
      </a>

      <a [routerLink]="[ '/insurance-records']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.ClaimHistory" title="Claim History">
        <img src="/assets/images/old-record.svg" alt="" srcset="">
        <span *ngIf="showMenuText">CLAIM HISTORY</span>
      </a>

      <a [routerLink]="[ '/laboratory']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.Laboratory" title="Laboratory">
        <img src="/assets/images/lab.svg" alt="" srcset="">
        <span *ngIf="showMenuText">LABORATORY</span>
      </a>

      <a [routerLink]="[ '/prescription']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.Prescriptions" title="Prescription">
        <img src="/assets/images/prescription.svg" alt="" srcset="">
        <span *ngIf="showMenuText">PRESCRIPTION</span>
      </a>

      <a [routerLink]="[ '/chart']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.Charts" title="Charts">
        <img src="/assets/images/chart.svg" alt="" srcset="">
        <span *ngIf="showMenuText">CHARTS</span>
      </a>

      <a [routerLink]="[ '/vhs']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="uiAccessList.Vhs" title="Vhs Laboratory">
        <img class="w-8" src="/assets/images/vhs-predection.svg" alt="" srcset="">
        <span *ngIf="showMenuText">VHS LABORATORY</span>
      </a>

      <a [routerLink]="[ '/comparison']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="[uiAccessList.ComparisonTable, uiAccessList.ReportComparison]"
        title="Comparison">
        <img class="w-8" src="/assets/images/compare.svg" alt="" srcset="">
        <span *ngIf="showMenuText">COMPARISON</span>
      </a>

      <a [routerLink]="[ '/radiology']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
        (click)="menuClick.emit(true)" [auth]="[uiAccessList.Radiology]" title="Radiology">
        <img class="w-8" src="/assets/images/radiology icon.svg" alt="" srcset="">
        <span *ngIf="showMenuText">RADIOLOGY</span>
      </a>

      <a [routerLink]="[ '/risk-score']" routerLinkActive="active" class="px-4 py-2 flex gap-2 items-center"
      (click)="menuClick.emit(true)" [auth]="[uiAccessList.RiskScore]" title="RiskScore">
      <img class="w-8" src="/assets/images/risk-meter-white.png" alt="" srcset="">
      <span *ngIf="showMenuText">RISK SCORE</span>
    </a>

    </div>
    <div class="footer-content pt-2 justify-end" *ngIf="showMenuText">
      <div>You are using beta version <span style="opacity: 1;">😊</span></div>
      <div>&copy; {{currentYear}} Algorithm Health Pvt Ltd.</div>
    </div>
    <div class="close-btn">
      <button mat-icon-button (click)="menuClick.emit(true)">
        <img src="/assets/images/close.svg">
      </button>
    </div>
  </div>
  <div class="h-28 w-6 bg-primary rounded-e-2xl relative right-2 flex items-center cursor-pointer"
    *ngIf="innerWidth > 900" (click)="showMenuText=!showMenuText">
    <img class="arrow-icon" [ngClass]="{'rotate': showMenuText}" src="/assets/images/sidenav-arrow.svg">
  </div>
</div>
